module.exports = __webpack_public_path__ + "static/img/connect02.100391e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/up/connect02.png
// module id = olc2
// module chunks = 1